<div class="container-fluid">
  <div class="page-title-area">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="page-title-content">
            <h1>مدونة المنصة</h1>
            <h2>اكتشف أحدث مقالاتنا</h2>
            <ul>
              <li><a routerLink="/">الرئيسية</a></li>
              <li>المدونة</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="default-shape">
      <div class="shape-1">
        <img src="assets/img/shape/1.png" alt="image" />
      </div>
      <div class="shape-2 rotateme">
        <img src="assets/img/shape/2.png" alt="image" />
      </div>
      <div class="shape-3">
        <img src="assets/img/shape/3.svg" alt="image" />
      </div>
      <div class="shape-4">
        <img src="assets/img/shape/4.svg" alt="image" />
      </div>
      <div class="shape-5">
        <img src="assets/img/shape/5.png" alt="image" />
      </div>
    </div>
  </div>

  <!-- Updated Filter Section -->
  <section class="filter-area mt-4">
    <div class="container-filters">
      <form (ngSubmit)="applyFilters()">
        <div class="filter-container">
          <div class="filter-header">
            <i class="fas fa-filter"></i>
            <h3>فلتر المقالات</h3>
          </div>

          <div class="row row-filter">
            <!-- Search Filter -->
            <div class="col-md-5 input_filter">
              <div class="search-box">
                <i class="fas fa-search"></i>
                <input
                  id="search"
                  type="text"
                  [(ngModel)]="filters.search"
                  name="search"
                  class="filter-input form-control"
                  placeholder="ابحث عن مقالات..."
                />
              </div>
            </div>

            <!-- Category Filter -->
            <div class="col-md-3 input_filter">
              <div class="category-filter">
                <i class="fas fa-tags"></i>
                <select
                  [(ngModel)]="filters.category"
                  name="category"
                  class="filter-input form-control"
                >
                  <option value="">جميع التصنيفات</option>
                  <option
                    *ngFor="let category of categories"
                    [value]="category.id"
                  >
                    {{ category.title }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Buttons -->
            <div class="button-group d-flex gap-2 col-md-4">
              <button type="submit" class="btn apply-filters-btn">
                <i class="fas fa-check-circle"></i> تطبيق البحث
              </button>
              <button
                type="button"
                class="clear-filters-btn btn"
                (click)="clearFilters()"
              >
                <i class="fas fa-broom"></i> مسح الفلتر
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>

  <!-- Blog Section -->
  <section class="blog-area">

    
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6" *ngFor="let article of articles"               [routerLink]="['/article']"
        [queryParams]="{ title: article?.title, id: article?.id }">
          <!-- Updated Blog Card (in the *ngFor loop) -->
          <div class="single-blog-post">
            <div class="image">
              <a
                [routerLink]="['/article']"
                [queryParams]="{ title: article?.title, id: article?.id }"
              >
                <img
                [routerLink]="['/article']"
                [queryParams]="{ title: article?.title, id: article?.id }"
                  style="width: 100%; height: 300px"
                  src="{{ server + article?.image?.public_url }}"
                  alt="{{ article?.title }}"
                />
              </a>
              <!-- Category Tag -->
              <div class="category-tag" *ngIf="article.category">
                {{ article.category.title }}
              </div>
            </div>

            <div class="content">
              <ul class="post-meta">
                <li>
                  <i class="fa fa-calendar"></i>
                  {{ article.createdAt | date : 'fullDate' }}
                </li>
              </ul>
              <h4>
                <a
                  [routerLink]="['/article']"
                  [queryParams]="{ title: article?.title, id: article?.id }"
                  >{{ article.title }}</a
                >
              </h4>

              <a
                [routerLink]="['/article']"
                [queryParams]="{ title: article?.title, id: article?.id }"
                class="read-more"
                >قراءة المزيد</a
              >
              <div class="average-rating">
                <span class="average-number">{{
                  article.averageRating | number : '1.1-1'
                }}</span>
                <div class="stars">
                  <mat-icon
                    *ngFor="let star of fullStars(article.averageRating)"
                    class="star-icon"
                    >star</mat-icon
                  >
                  <mat-icon
                    *ngIf="halfStar(article.averageRating)"
                    class="star-icon"
                    >star_half</mat-icon
                  >
                  <mat-icon
                    *ngFor="let star of emptyStars(article.averageRating)"
                    class="star-icon"
                    >star_border</mat-icon
                  >
                </div>
                <p>({{ article.reviewsCount }})</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination Section -->
      <!-- Pagination Section -->
      <div *ngIf="articles && articles.length === 0" class="mt-4 text-center">
        عذرًا، لا توجد مقالات متوافقة مع البحث
      </div>
      <!-- Pagination Section -->
      <div *ngIf="articles?.length > 0" class="pagination-container">
        <div class="pagination">
          <!-- زر الصفحة الأولى -->
          <button
            (click)="changePage(1)"
            [disabled]="currentPage === 1"
            class="pagination-button"
          >
            &laquo;
          </button>
      
          <!-- زر الصفحة السابقة -->
          <button
            (click)="changePage(currentPage - 1)"
            [disabled]="currentPage === 1"
            class="pagination-button"
          >
            &lsaquo;
          </button>
      
          <!-- أرقام الصفحات -->
          <button
            *ngFor="let page of getPaginationPages()"
            (click)="changePage(page)"
            [class.active]="currentPage === page"
            class="pagination-button"
          >
            {{ page }}
          </button>
      
          <!-- زر الصفحة التالية -->
          <button
            (click)="changePage(currentPage + 1)"
            [disabled]="currentPage === totalPages"
            class="pagination-button"
          >
            &rsaquo;
          </button>
      
          <!-- زر الصفحة الأخيرة -->
          <button
            (click)="changePage(totalPages)"
            [disabled]="currentPage === totalPages"
            class="pagination-button"
          >
            &raquo;
          </button>
        </div>
      
        <div class="pagination-info">
          عرض {{ (currentPage - 1) * filters.limit + 1 }} -
          {{ (currentPage * filters.limit) > totalArticles ? totalArticles : (currentPage * filters.limit) }} من
          {{ totalArticles }} مقال
        </div>
      </div>

    
    </div>

    <div class="default-shape">
      <div class="shape-1">
        <img src="assets/img/shape/1.png" alt="image" />
      </div>
      <div class="shape-2 rotateme">
        <img src="assets/img/shape/2.png" alt="image" />
      </div>
      <div class="shape-3">
        <img src="assets/img/shape/3.svg" alt="image" />
      </div>
      <div class="shape-4">
        <img src="assets/img/shape/4.svg" alt="image" />
      </div>
      <div class="shape-5">
        <img src="assets/img/shape/5.png" alt="image" />
      </div>
    </div>
  </section>
</div>
